import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import TableComponent from './TableComponent';
import styles from './componentStyles'; // Import the styles object
import EmailEntryOverlay from './EmailEntryOverlay';

const WinnerScreen = ({ winnerItems, toggleComponent, project }) => {

  const { button1Link, button2Text, button3Text, button2Link, button3Link } = project;

  const winner = winnerItems[0];
  const [link, setLink] = useState(null);

  const handleButtons = (linkEmail, message) => {
    setLink({
      linkEmail,
      message
    })
  }

  return (
    <div>
      <div style={styles.backArrow()}>
        <IconButton
          style={{ backgroundColor: 'white', marginTop: '10px', marginLeft: '40px' }}
          aria-label="back"
          sx={{
            '&:hover': {
              backgroundColor: 'rgb(43, 30, 94)', // Example: Change background color on hover
            },
          }}
          onClick={() => toggleComponent()}
        >
          <ArrowBackIcon style={{ color: 'rgb(43, 30, 94)' }} />
        </IconButton>
      </div>
      <header style={styles.appHeader()}>
        <h1 style={styles.headerTitle(project)}>
          Congratulations! You've just saved hours of research :)
        </h1>
      </header>
      <div style={styles.listContainer2()}>
        <div style={styles.imageText(project)}>
          You're most suited for...
        </div>
        <img style={styles.floatingImage()} src={winner.image} alt="Logo" />
      </div>
      <div style={styles.reportButtonsContainer()}>
        <div style={styles.reportButton(project)} onClick={() => window.open(button1Link, '_blank')}>
          Request A Quote
        </div>
        <div style={styles.reportButton(project)} onClick={() => handleButtons(button2Link, button2Text)}>
          Visit Product Site
        </div>
      </div>
      <div style={styles.submitButtonContainer()}>
        <div style={styles.submitButton2(project)} onClick={() => handleButtons(button3Link, button3Text)}>
          Download Full Comparison Report
        </div>
      </div>
      {/* <TableComponent data={winnerItems} /> */}
      <EmailEntryOverlay
        project={project}
        link={link}
        setLink={setLink}
      />
    </div>
  );
};

export default WinnerScreen;
